"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWellknownOpenidConfiguration = exports.getUserInfo = exports.getJwksUri = void 0;
var _utils = require("../utils");
var _paramKeys = _interopRequireDefault(require("./paramKeys"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// We must use a client with no parameters in order to have required/optional match the API spec

// This is defined here, rather than `types.ts`, because it relies on `Client` and `QueryKeys`,
// and making those generic would add too much complexity.

const getUserInfo = exports.getUserInfo = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/oauth2/userinfo'],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getUserInfo'], ...(0, _utils.getCustomKeys)(params)];
    return [...getUserInfo.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getWellknownOpenidConfiguration = exports.getWellknownOpenidConfiguration = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/oauth2/.well-known/openid-configuration'],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getWellknownOpenidConfiguration'], ...(0, _utils.getCustomKeys)(params)];
    return [...getWellknownOpenidConfiguration.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getJwksUri = exports.getJwksUri = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/oauth2/jwks'],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getJwksUri'], ...(0, _utils.getCustomKeys)(params)];
    return [...getJwksUri.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};